const mutations = {
    COMMIT_MESSAGE: (state, payload) => {
        state.message = payload
    },

    COMMIT_MESSAGE_TYPE: (state, payload) => {
        state.isError = !payload
    },

    COMMIT_WARNING: (state, payload) => {
        state.warning = payload
    },
}

export default mutations
